var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCircleInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 24C8.6875 24 4.75 21.75 2.59375 18C0.4375 14.2969 0.4375 9.75 2.59375 6C4.75 2.29688 8.6875 0 13 0C17.2656 0 21.2031 2.29688 23.3594 6C25.5156 9.75 25.5156 14.2969 23.3594 18C21.2031 21.75 17.2656 24 13 24ZM11.125 15.75C10.4688 15.75 10 16.2656 10 16.875C10 17.5312 10.4688 18 11.125 18H14.875C15.4844 18 16 17.5312 16 16.875C16 16.2656 15.4844 15.75 14.875 15.75H14.5V11.625C14.5 11.0156 13.9844 10.5 13.375 10.5H11.125C10.4688 10.5 10 11.0156 10 11.625C10 12.2812 10.4688 12.75 11.125 12.75H12.25V15.75H11.125ZM13 6C12.1562 6 11.5 6.70312 11.5 7.5C11.5 8.34375 12.1562 9 13 9C13.7969 9 14.5 8.34375 14.5 7.5C14.5 6.70312 13.7969 6 13 6Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleInfo);
export default __webpack_public_path__ + "static/media/icon-circle-info.45c05395fd267a98018bebbfc22d1926.svg";
export { ForwardRef as ReactComponent };